import { ALL_VISITS_TAB, AllVisitsPageNS } from '@/pages/AllVisitsPage/AllVisitsPage.types';
import { VisitFilter, VisitOutcome, VisitState, VisitWorkflowStep } from 'gql-types';

/**
 * Visit-side filter for each primary tab on the All Visits page. Used by both
 * the count query (useCounts) and the per-tab list queries (useBulkViewFilters,
 * UnifiedAllVisitsTable).
 */
export const VIEW_FILTERS: Record<AllVisitsPageNS.PrimaryTab, VisitFilter> = {
    // The "All" tab is view-only and applies no state/workflow filter — the
    // base filters (date range, dialog filters, patient search) still apply.
    [ALL_VISITS_TAB]: {},
    [VisitWorkflowStep.NEEDS_SERVICE]: {
        workflowStep: { exact: VisitWorkflowStep.NEEDS_SERVICE },
        outcome: { exact: VisitOutcome.NONE },
        NOT: {
            hasRelatedOrder: {
                isDiscontinued: { exact: true },
            },
        },
    },
    [VisitWorkflowStep.NEEDS_CLINICIAN]: {
        workflowStep: { exact: VisitWorkflowStep.NEEDS_CLINICIAN },
        outcome: { exact: VisitOutcome.NONE },
        NOT: {
            hasRelatedOrder: {
                isDiscontinued: { exact: true },
            },
        },
    },
    [VisitWorkflowStep.NEEDS_DATE]: {
        workflowStep: { exact: VisitWorkflowStep.NEEDS_DATE },
        outcome: { exact: VisitOutcome.NONE },
        NOT: {
            hasRelatedOrder: {
                isDiscontinued: { exact: true },
            },
        },
    },
    [VisitState.UNSCHEDULED]: { state: { exact: VisitState.UNSCHEDULED } },
    [VisitState.SCHEDULED]: { state: { exact: VisitState.SCHEDULED } },
    [VisitState.CONFIRMED]: { state: { exact: VisitState.CONFIRMED } },
    [VisitState.EN_ROUTE]: { state: { exact: VisitState.EN_ROUTE } },
    [VisitState.AT_LOCATION]: { state: { exact: VisitState.AT_LOCATION } },
    [VisitState.IN_REVIEW]: { state: { exact: VisitState.IN_REVIEW } },
    [VisitState.ENDED]: { state: { exact: VisitState.ENDED } },
};
